import {countryList} from '../adyen'

export const getCountryName = (countryCode) =>
    countryList?.find(({value}) => value === countryCode)?.label ?? ''
